import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive, Router } from '@angular/router';

declare var bootstrap: any;

@Component({
  selector: 'app-action-bar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './action-bar.component.html',
  styleUrl: './action-bar.component.css'
})
export class ActionBarComponent {
  constructor(private router: Router) {}

  closeSideMenu() {
    const offcanvasElement = document.getElementById('sidePanel');
    if (offcanvasElement) {
      const offcanvasInstance = bootstrap.Offcanvas.getInstance(offcanvasElement);
      if (offcanvasInstance) {
        offcanvasInstance.hide();
      }
      // Clean up backdrop and body styles after a short delay
      setTimeout(() => {
        const backdrop = document.querySelector('.offcanvas-backdrop');
        if (backdrop) {
          backdrop.remove();
        }
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
      }, 100);
    }
  }

  navigateToBoard(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    
    const offcanvasElement = document.getElementById('sidePanel');
    
    if (offcanvasElement) {
      // Set up one-time listener for when offcanvas is fully hidden
      const handleHidden = () => {
        // Aggressive cleanup
        const backdrops = document.querySelectorAll('.offcanvas-backdrop, .modal-backdrop');
        backdrops.forEach(backdrop => backdrop.remove());
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        document.body.style.pointerEvents = '';
        
        // Remove the event listener
        offcanvasElement.removeEventListener('hidden.bs.offcanvas', handleHidden);
        
        // Navigate after cleanup
        this.router.navigate(['/board']).then(() => {
          // Final cleanup after navigation completes
          setTimeout(() => {
            // Remove any remaining backdrops
            const remainingBackdrops = document.querySelectorAll('.offcanvas-backdrop, .modal-backdrop');
            remainingBackdrops.forEach(backdrop => backdrop.remove());
            document.body.classList.remove('modal-open');
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
            document.body.style.pointerEvents = '';
            
            // Ensure all elements are interactive
            document.body.style.cursor = '';
          }, 10);
        });
      };
      
      // Listen for the hidden event
      offcanvasElement.addEventListener('hidden.bs.offcanvas', handleHidden, { once: true });
      
      // Close the menu
      const offcanvasInstance = bootstrap.Offcanvas.getInstance(offcanvasElement);
      if (offcanvasInstance) {
        offcanvasInstance.hide();
      } else {
        // If no instance exists, create one and hide it
        const newInstance = new bootstrap.Offcanvas(offcanvasElement);
        newInstance.hide();
      }
    } else {
      // If element doesn't exist, just navigate
      this.router.navigate(['/board']);
    }
  }
}
